module.exports = __webpack_public_path__ + "img/a6a028b.png";